import router from './router'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { Route } from 'vue-router'
import store from './store'

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach(async (to: Route, _: Route, next: any) => {
    NProgress.start()
    if (store.state.token) {
        if (to.path === '/login') {
            next({ path: '/login' })
            NProgress.done()
        } else {
            // Check whether the user has obtained his permission roles
            next()
            // next({path:"/404"})
            NProgress.done()
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next()
        } else {
            next('/login')
            NProgress.done()
        }
    }
    // next()
    NProgress.done()
})

router.afterEach(() => {
    NProgress.done() // 结束Progress
})
